import { useSelector } from 'react-redux'

import { selectWebapiJWT } from '../../state/selectors/webapi-jwt'

export const useWebapiJWT = () => useSelector(selectWebapiJWT)
